import { createAction, props } from '@ngrx/store';

import { ItemsPagination } from 'src/app/model/api/data-rest';
import { PaginationParams } from 'src/app/model/api/pagination-params';
import { Permission, PermittedCommand, PermissionTemplate, PermittedThs, AccessPermission } from 'src/app/model/permission';
import { Thermo } from 'src/app/model/thermo';
import { UserFile } from 'src/app/model/user-file';


export const getPermissions = createAction('GET_PERMISSIONS', props<{
	paging?: PaginationParams;
	filter?: string;
	activeFilter?: boolean;
	readyFilter?: boolean;
	expiredFilter?: boolean;
	createdFilter?: boolean;
}>());
export const getPermissionsSuccess = createAction('GET_PERMISSIONS_SUCCESS', props<{
	paging: ItemsPagination;
	permissions: Permission[];
}>());
export const getPermissionsFailed = createAction('GET_PERMISSIONS_FAILED', props<{ errorMessage: string }>());

/* export const getPermissionsExpired = createAction('GET_PERMISSIONS_EXPIRED');
export const getPermissionsExpiredSuccess = createAction('GET_PERMISSIONS_EXPIRED_SUCCESS', props<{
	 permissions: Permission[];
}>());
export const getPermissionsExpiredFailed = createAction('GET_PERMISSIONS_EXPIRED_FAILED', props<{ errorMessage: string }>()); */

export const getPermissionsCalendar = createAction('GET_PERMISSIONS_CALENDAR', props<{
	datefrom?: string;
	dateto?: string;
}>());
export const getPermissionsCalendarSuccess = createAction('GET_PERMISSIONS_CALENDAR_SUCCESS', props<{
	paging: ItemsPagination;
	permissionsCalendar: Permission[];
}>());
export const getPermissionsCalendarFailed = createAction('GET_PERMISSIONS_CALENDAR_FAILED', props<{ errorMessage: string }>());

export const getPermittedCommands = createAction('GET_PERMITTED_COMMANDS');
export const getPermittedCommandsSuccess = createAction('GET_PERMITTED_COMMANDS_SUCCESS', props<{
	permittedCommands: PermittedCommand[];
}>());
export const getPermittedCommandsFailed = createAction('GET_PERMITTED_COMMANDS_FAILED', props<{ errorMessage: string }>());

export const getPermittedThs = createAction('GET_PERMITTED_THS');
export const getPermittedThsSuccess = createAction('GET_PERMITTED_THS_SUCCESS', props<{
	permittedThs: PermittedThs[];
}>());
export const getPermittedThsFailed = createAction('GET_PERMITTED_THS_FAILED', props<{ errorMessage: string }>());

export const getPermission = createAction('GET_PERMISSION', props<{ permissionId?: number; token?: string }>());
export const getPermissionSuccess = createAction('GET_PERMISSION_SUCCESS', props<{ permission: Permission }>());
export const getPermissionFailed = createAction('GET_PERMISSION_FAILED', props<{ errorMessage: string }>());

export const resetPermissionForm = createAction('RESET_PERMISSION_FORM');
export const addPermission = createAction('ADD_PERMISSION', props<{
	permission: Permission; permissionCommands: PermittedCommand[]; permissionThs: PermittedThs[];
}>());
export const addPermissionSuccess = createAction('ADD_PERMISSION_SUCCESS', props<{ permission: Permission; message: string }>());
export const addPermissionFailed = createAction('ADD_PERMISSION_FAILED', props<{ errorMessage: string }>());

export const editPermission = createAction('EDIT_PERMISSION', props<{
	permission: Permission; permissionCommands: PermittedCommand[]; permissionThs: PermittedThs[];
}>());
export const editPermissionSuccess = createAction('EDIT_PERMISSION_SUCCESS', props<{ permission: Permission; message: string }>());
export const editPermissionFailed = createAction('EDIT_PERMISSION_FAILED', props<{ errorMessage: string }>());

export const deletePermission = createAction('DELETE_PERMISSION', props<{ permission: Permission }>());
export const deletePermissionSuccess = createAction('DELETE_PERMISSION_SUCCESS', props<{ permissionId: number; message: string }>());
export const deletePermissionFailed = createAction('DELETE_PERMISSION_FAILED', props<{ errorMessage: string }>());

export const resetPin = createAction('RESET_PIN', props<{ permissionId: number }>());
export const resetPinSuccess = createAction('RESET_PIN_SUCCESS', props<{ message: string }>());
export const resetPinFailed = createAction('RESET_PIN_FAILED', props<{ errorMessage: string }>());

export const setPin = createAction('SET_PIN', props<{ token: string; pin: string }>());
export const setPinSuccess = createAction('SET_PIN_SUCCESS', props<{ message: string }>());
export const setPinFailed = createAction('SET_PIN_FAILED', props<{ errorMessage: string }>());

export const getTokenPermissionCommands = createAction('GET_TOKEN_PERMISSION_COMMANDS', props<{ token: string }>());
export const getTokenPermissionCommandsSuccess = createAction('GET_TOKEN_PERMISSION_COMMANDS_SUCCESS', props<{
	accessPermission: AccessPermission;
}>());
export const getTokenPermissionCommandsFailed = createAction('GET_TOKEN_PERMISSION_COMMANDS_FAILED', props<{ errorMessage: string }>());

export const executeTokenCommand = createAction('EXECUTE_TOKEN_COMMAND', props<{
	token: string; pin: string; command?: PermittedCommand; thCommand?: Thermo;
}>());
export const executeTokenCommandSuccess = createAction('EXECUTE_TOKEN_COMMAND_SUCCESS', props<{ message: string }>());
export const executeTokenCommandPinCheckFailed = createAction(
	'EXECUTE_TOKEN_COMMAND_PIN_CHECK_FAILED',
	props<{ errorMessage: string; errorCode?: number }>()
);
export const executeTokenCommandFailed = createAction('EXECUTE_TOKEN_COMMAND_FAILED', props<{ errorMessage: string }>());

export const permissionCreatedNotification = createAction('PERMISSION_CREATED_NOTIFICATION', props<{ message: string }>());
export const permissionStatusNotification = createAction('PERMISSION_STATUS_NOTIFICATION', props<{
	message: string; permissionId: number; status: string;
}>());

export const getPermissionTemplates = createAction('GET_PERMISSION_TEMPLATES', props<{ siteId?: number }>());
export const getPermissionTemplatesSuccess = createAction(
	'GET_PERMISSION_TEMPLATES_SUCCESS',
	props<{ templates: PermissionTemplate[] }>()
);
export const getPermissionTemplatesFailed = createAction('GET_PERMISSION_TEMPLATES_FAILED', props<{ errorMessage: string }>());

export const getPermissionTemplate = createAction('GET_PERMISSION_TEMPLATE', props<{ siteId: number; templateId: number }>());
export const getPermissionTemplateSuccess = createAction('GET_PERMISSION_TEMPLATE_SUCCESS', props<{ message: string }>());
export const getPermissionTemplateFailed = createAction('GET_PERMISSION_TEMPLATE_FAILED', props<{ errorMessage: string }>());

export const setPermissionTemplate = createAction('SET_PERMISSION_TEMPLATE', props<{ data: PermissionTemplate }>());
export const setPermissionTemplateSuccess = createAction('SET_PERMISSION_TEMPLATE_SUCCESS', props<{ message: string }>());
export const setPermissionTemplateFailed = createAction('SET_PERMISSION_TEMPLATE_FAILED', props<{ errorMessage: string }>());

export const deletePermissionTemplate = createAction('DELETE_PERMISSION_TEMPLATE', props<{ data: PermissionTemplate }>());
export const deletePermissionTemplateSuccess = createAction('DELETE_PERMISSION_TEMPLATE_SUCCESS', props<{ message: string }>());
export const deletePermissionTemplateFailed = createAction('DELETE_PERMISSION_TEMPLATE_FAILED', props<{ errorMessage: string }>());

export const resetPermissionTemplateForm = createAction('RESET_PERMISSION_TEMPLATE_FORM');
export const savePermissionTemplate = createAction('SAVE_PERMISSION_TEMPLATE', props<{
	userId?: number; siteId?: number; template: PermissionTemplate; logo: UserFile;
}>());
export const savePermissionTemplateSuccess = createAction('SAVE_PERMISSION_TEMPLATE_SUCCESS', props<{ message: string }>());
export const savePermissionTemplateFailed = createAction('SAVE_PERMISSION_TEMPLATE_FAILED', props<{
	fileId?: string; errorMessage: string;
}>());
export const saveEmailLogoSuccess = createAction('SAVE_EMAIL_LOGO_SUCCESS', props<{ siteId: number; template: PermissionTemplate }>());

export const updatePermissionTemplate = createAction('UPDATE_PERMISSION_TEMPLATE', props<{
	userId?: number; siteId?: number; template: PermissionTemplate; logo: UserFile;
}>());
export const updatePermissionTemplateSuccess = createAction('UPDATE_PERMISSION_TEMPLATE_SUCCESS', props<{ message: string }>());
export const updatePermissionTemplateFailed = createAction('UPDATE_PERMISSION_TEMPLATE_FAILED', props<{ errorMessage: string }>());
export const updateEmailLogoSuccess = createAction('UPDATE_EMAIL_LOGO_SUCCESS', props<{ siteId: number; template: PermissionTemplate }>());

export const getPermissionTemplateLogo = createAction('GET_PERMISSION_TEMPLATE', props<{ fileId: string }>());
export const getPermissionTemplateLogoSuccess = createAction('GET_PERMISSION_TEMPLATE_LOGO_SUCCESS', props<{ fileContent: string }>());
export const getPermissionTemplateLogoFailed = createAction('GET_PERMISSION_TEMPLATE_LOGO_FAILED', props<{ errorMessage: string }>());

export const resetPinToken = createAction('RESET_PIN_TOKEN', props<{
	token: string;
}>());
export const resetPinTokenSuccess = createAction('RESET_PIN_TOKEN_SUCCESS', props<{ message: string }>());
export const resetPinTokenFailed = createAction(
	'RESET_PIN_TOKEN_FAILED',
	props<{ errorMessage: string; errorCode?: number }>()
);

export const deletePermissionExpired = createAction('DELETE_PERMISSION_EXPIRED', props<{ siteId: number }>());
export const deletePermissionExpiredSuccess = createAction('DELETE_PERMISSION_EXPIRED_SUCCESS', props<{ message: string }>());
export const deletePermissionExpiredFailed = createAction('DELETE_PERMISSION_EXPIRED_FAILED', props<{ errorMessage: string }>());